import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AssignedAssessmentsList from "./AssignedAssessmentsList";
import ScrollableCard from "../../../../SharedComponents/ScrollableCard";

const AssignedAssessments = ({ tickets }) => {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" ? window.innerWidth < 768 : false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={"pt-4"}>
      {/*<Row className="justify-content-between mt-3 mx-0">
        <Col xs="auto" className="text-14 text-color-gray-light fw-medium">
          {t("assignedAssessmentsHeader")}
        </Col>
      </Row>*/}
      <ScrollableCard emptySpaceHeight={50} top={0} maximumHeight={isMobile && 600}>
        <AssignedAssessmentsList />
      </ScrollableCard>
    </div>
  );
};

export default AssignedAssessments;
